const LogoPodcasts = ({ width, height, color, waveColor }) => {
  return (
    <svg
      width={width ? width : "93px"}
      height={height ? height : "64px"}
      viewBox="0 0 93 64"
    >
      <rect y="25.0924" width="1.99756" height="12.8584" fill="#005774" />
      <rect
        x="67.9121"
        y="25.0924"
        width="1.99756"
        height="12.8584"
        fill="#005774"
      />
      <rect
        x="90.6328"
        y="25.0924"
        width="1.99756"
        height="12.8584"
        fill="#005774"
      />
      <rect
        x="79.2725"
        y="20.5983"
        width="1.99756"
        height="21.597"
        fill="#005774"
      />
      <path
        d="M11.3604 20.5983H13.3579V42.1953H11.3604V20.5983Z"
        fill="#005774"
      />
      <path
        d="M56.5518 20.5983H58.5494V42.1953H56.5518V20.5983Z"
        fill="#005774"
      />
      <rect
        x="22.7207"
        y="11.1371"
        width="1.99756"
        height="40.9204"
        fill="#005774"
      />
      <rect
        x="45.4414"
        y="11.1371"
        width="1.99756"
        height="40.9204"
        fill="#005774"
      />
      <rect x="34.0811" width="1.99756" height="63.4178" fill="#005774" />
    </svg>
  );
};

export default LogoPodcasts;
